import axios from 'axios'

export const apiService = {
  getMainMenuResults,
  xlsxgen,
  getFilterOptions,
  getL2DCOptions,
  getL3MCOptions,
  getL4MPOptions,
  tickOKTL,
  getHousehold,
  getContactDetails,
  getIndividualDetails,
  getHouseholdDetails,
  getLocation,
  getHouseholdStatus,
  getHouseholdNotes,
  getAddNote,
  setNoteRead,
  getUnreadNotes,
  addNewNote,
  getHouseholdVisits,
  getHouseholdExceptions,
  getAddHouseholdException,
  addNewHouseholdException,
  getAddIndividualException,
  addNewIndividualException,
  getBeneficiaryListFilterOptions,
  getBeneficiaryList,
  editBeneficiaryList,
}

function xlsxgen(params) {
  return axios({
    url: '/api/xlsxgen',
    method: 'POST',
    responseType: 'blob',
    data: params
  })
  .then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'report.xlsx')
    document.body.appendChild(link)
    link.click()
    link.parentNode.removeChild(link)
  })
}

/* main page */

function getMainMenuResults(params) {
  return axios.post('/api/mainmenuresults', params)
}

function getFilterOptions() {
  return axios.get('/api/mainmenufilteroptions')
}

function getL2DCOptions(PCode) {
  return axios.post('/api/l2dc', {"PCode": PCode})
}

function getL3MCOptions(DCCode) {
  return axios.post('/api/l3mc', {"DCCode": DCCode})
}

function getL4MPOptions(MCCode) {
  return axios.post('/api/l4mp', {"MCCode": MCCode})
}

function tickOKTL(checked, hhid) {
  return axios.post('/api/tickoktl', {
    Checked: checked,
    HHID: hhid,
  })
}

/* household page */

function getHousehold(HHID) {
  return axios.post('/api/household', {"HHID": HHID})
}

/* contact details page */

function getContactDetails(HHID) {
  return axios.post('/api/contactdetails', {"HHID": HHID})
}

/* individual details page */

function getIndividualDetails(HHID, PID) {
  return axios.post('/api/individualdetails', {
    "HHID": HHID,
    "PID": PID,
  })

} 

/* household details page */

function getHouseholdDetails(HHID) {
  return axios.post('/api/householddetails', {"HHID": HHID})

}

/* location details page */

function getLocation(HHID) {
  return axios.post('/api/location', {"HHID": HHID})
}

/* household status page */

function getHouseholdStatus(HHID) {
  return axios.post('/api/householdstatus', {"HHID": HHID})
}

/* household notes page */

function getHouseholdNotes(HHID) {
  return axios.post('/api/householdnotes', {"HHID": HHID})
}

function setNoteRead(noteID) {
  return axios.post('/api/setnoteread', {NoteID: noteID})
} 

function getUnreadNotes() {
  return axios.get('/api/getunreadnotes')
}

/* add note page */
function getAddNote(HHID) {
  return axios.post('/api/addnote', {"HHID": HHID})
}

function addNewNote(HHID, ToUserID, Note) {
  return axios.post('/api/addnewnote', {
    "HHID": HHID,
    "ToUserID": Number(ToUserID),
    "Note": Note,
  })
}

/* household visits page */

function getHouseholdVisits(HHID) {
  return axios.post('/api/householdvisits', {"HHID": HHID})
}

/* exceptions page */

function getHouseholdExceptions(HHID) {
  return axios.post('/api/householdexceptions', {"HHID": HHID})
}

/* add household exceptions page */

function getAddHouseholdException(HHID) {
  return axios.post('/api/addhouseholdexception', {"HHID": HHID})
}

function addNewHouseholdException(HHID, TheIssue, Accept, SuccessfulInterview) {
  return axios.post('/api/addnewhouseholdexception', {
    "HHID": HHID,
    "TheIssue": TheIssue,
    "Accept": Accept,
    "SuccessfulInterview": SuccessfulInterview,
  })
}

/* add individual exceptions page */

function getAddIndividualException(HHID) {
  return axios.post('/api/addindividualexception', {"HHID": HHID})
}

function addNewIndividualException(HHID, PID, TheIssue, Accept, SuccessfulInterview) {
  return axios.post('/api/addnewindividualexception', {
    "HHID": HHID,
    "PID": PID,
    "TheIssue": TheIssue,
    "Accept": Accept,
    "SuccessfulInterview": SuccessfulInterview,
  })
}

/* beneficiary list page */ 

function getBeneficiaryListFilterOptions() {
  return axios.post('/api/beneficiarylistfilteroptions')
}

function getBeneficiaryList(interviewerID, claimID, progress, province, assignedHQ, pageNum, pageSize) {
  return axios.post('/api/beneficiarylist', {
    InterviewerID: interviewerID,
    ClaimID: claimID,
    Progress: progress,
    Province: province,
    AssignedHQ: assignedHQ,
    PageNum: pageNum,
    PageSize: pageSize,
  })  
}

function editBeneficiaryList(benSK, teamLeader, province, beneficiary, homeNumber, cellNumber, workNumber, address, comment, progress, inField, assignedHQ) {
  return axios.post('/api/editbeneficiarylist', {
    BenSK: benSK,
    TeamLeader: teamLeader,
    Province: province,
    Beneficiary: beneficiary,
    HomeNumber: homeNumber,
    CellNumber: cellNumber,
    WorkNumber: workNumber,
    Address: address,
    Comment: comment,
    Progress: progress,
    InField: inField,
    AssignedHQ: assignedHQ,
  })
}


// WEBPACK FOOTER //
// ./src/_services/api.service.js